/** A length of time in a few characters: "5 d", "3 wk", "4 mo"; none for nothing or a point. */
export const span = (days: number | null) => (days === null ? null : days === 0 ? null : days < 14 ? `${days} d` : days < 70 ? `${Math.round(days / 7)} wk` : `${Math.round(days / 30)} mo`);
